import { createFileRoute } from '@tanstack/react-router';
import { PayMethodPage } from '@/features/rules/pages/pay-method-page';

export const Route = createFileRoute('/_app/pay-method')({ component: PayMethodPage });
